export default [
  {
    name: "demo-index",
    component: () => import("@/pages/demo/index"),
    path: "/demo",
    meta: {
      title: "demo",
    },
  },
];
